import { UAParser } from 'ua-parser-js';

const USER_AGENT_PARSED = new UAParser().getResult();
const BROWSER_NAME = USER_AGENT_PARSED.browser.name;
const OS_NAME = USER_AGENT_PARSED.os.name;

/*
  When run in headless environment, USER_AGENT_PARSED returns:
  {
    ua: 'Mozilla/5.0 (darwin) AppleWebKit/537.36 (KHTML, like Gecko) jsdom/11.12.0',
    browser: { name: 'WebKit', version: '537.36', major: '537' },
    engine: { name: 'WebKit', version: '537.36' },
    os: { name: undefined, version: undefined },
    device: { vendor: undefined, model: undefined, type: undefined },
    cpu: { architecture: undefined }
  }
 */

// TODO: Determine if IIFEs were required for scope reasons or if we can rely
// on more shared property access (like BROWSER_NAME)
const isDesktop = ((): boolean => {
  const userAgentOsName = USER_AGENT_PARSED.os.name;

  if (!userAgentOsName) return false;

  const isWindows = userAgentOsName.indexOf('Windows') !== -1;
  const isMac = userAgentOsName.indexOf('Mac') !== -1;
  return isWindows || isMac;
})();

const isMobile = ((): boolean => {
  const isMobileDevice = USER_AGENT_PARSED.device.type === 'mobile';
  return isMobileDevice || !isDesktop;
})();

const isRetina = ((): boolean => window.devicePixelRatio > 1)();

const isFacebookInApp = ((): boolean => {
  const browserName = USER_AGENT_PARSED.browser.name || '';
  return browserName.indexOf('Facebook') !== -1;
})();

const isIOS12 = ((): boolean => {
  const osName = USER_AGENT_PARSED.os.name;
  const osVersion = USER_AGENT_PARSED.os.version;

  if (!osName || !osVersion) return false;

  return osName === 'iOS' && osVersion.startsWith('12');
})();

const isChrome = !!BROWSER_NAME && BROWSER_NAME.includes('Chrome');

const isSafari = !!BROWSER_NAME && BROWSER_NAME.includes('Safari');

const isFirefox = !!BROWSER_NAME && BROWSER_NAME.includes('Firefox');

const isIOS = !!OS_NAME && OS_NAME.includes('iOS');

const isAndroid = !!OS_NAME && OS_NAME.includes('Android');

const isWindows = !!OS_NAME && OS_NAME.includes('Windows');

const isMacOS = !!OS_NAME && OS_NAME.includes('Mac');

const isEmbeddediOS = ((): boolean => {
  const standAlone =
    // @ts-expect-error
    'standalone' in window.navigator && Boolean(window.navigator.standalone);
  return isIOS && standAlone && isSafari;
})();

const isEmbeddedAndroid = USER_AGENT_PARSED.ua.includes('wv');

const isEmbeddedWebView = ((): boolean => {
  if (!isMobile) return false;

  return isEmbeddediOS || isEmbeddedAndroid;
})();

export default {
  isDesktop,
  isMobile,
  isRetina,
  isFacebookInApp,
  isEmbeddedWebView,
  isIOS,
  isIOS12,
  isMacOS,
  isAndroid,
  isWindows,
  isSafari,
  isChrome,
  isFirefox,
  USER_AGENT_PARSED,
};
